// extracted by mini-css-extract-plugin
export default {"content":"music-content_content__Bw6a9"};